import {DropdownMenu} from '@wandb/components';
import React from 'react';

type RunCopyIdentifiersSubmenuProps = {
  onCopyRunName: () => void;
  onCopyRunPath: () => void;
};

export function RunCopyIdentifiersSubmenu({
  onCopyRunName,
  onCopyRunPath,
}: RunCopyIdentifiersSubmenuProps) {
  return (
    <DropdownMenu.SubTrigger>
      <DropdownMenu.Item>
        <DropdownMenu.ItemDecorationLeft iconProps={{icon: 'copy'}} />
        <DropdownMenu.ItemLabel>Copy...</DropdownMenu.ItemLabel>
      </DropdownMenu.Item>
      <DropdownMenu.Content>
        <DropdownMenu.Item onAction={onCopyRunName}>
          <DropdownMenu.ItemLabel>Run name</DropdownMenu.ItemLabel>
        </DropdownMenu.Item>
        <DropdownMenu.Item onAction={onCopyRunPath}>
          <DropdownMenu.ItemLabel>Run path</DropdownMenu.ItemLabel>
        </DropdownMenu.Item>
      </DropdownMenu.Content>
    </DropdownMenu.SubTrigger>
  );
}
